<template lang="pug">
  .courses_folder
    .courses-cards
      .courses-cards__list
        EmptyCourse(
          :root="true"
          v-for="item in 4" :key="item"
        )
</template>

<script>
import EmptyCourse from './layouts/EmptyCourse';

export default {
  components: { EmptyCourse }
};
</script>
